import { Routes } from '@angular/router';
import { AdminComponent } from './view/layout/admin/admin.component';
import { AuthGuard } from './data/guard/auth.guard';
import { RoleGuard } from './data/guard/role.guard';
import { Roles } from './model';
const rol = Roles;
const ɵ0 = { rolUsuario: [rol.administrador] }, ɵ1 = () => import("./view/pages/inicio/inicio.module.ngfactory").then(module => module.InicioModuleNgFactory), ɵ2 = () => import("./view/pages/peticiones/peticiones.module.ngfactory").then(module => module.PeticionesModuleNgFactory), ɵ3 = { rolUsuario: [rol.administrador] }, ɵ4 = () => import("./view/pages/administrador/administrador.module.ngfactory").then(module => module.AdministradorModuleNgFactory);
const routes = [
    {
        path: 'login',
        loadChildren: './view/pages/login/login.module#LoginModule',
    },
    {
        path: '',
        component: AdminComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                redirectTo: 'inicio',
                pathMatch: 'full'
            },
            {
                path: 'inicio',
                canActivate: [RoleGuard],
                data: ɵ0,
                loadChildren: ɵ1
            },
            {
                path: 'peticiones',
                canActivate: [AuthGuard],
                loadChildren: ɵ2
            },
            {
                path: 'administrador',
                canActivate: [RoleGuard],
                data: ɵ3,
                loadChildren: ɵ4
            },
        ]
    },
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
